var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraph = function SvgGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M25.282 8.108c-.747-2.531-2.858-4.643-5.39-5.39-1.925-.56-3.255-.513-4.177.175-1.108.829-1.236 2.322-1.236 3.384v2.905c0 2.87 1.306 4.328 3.873 4.328H21.7c1.05 0 2.555-.128 3.384-1.237.711-.91.77-2.24.198-4.165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M22.062 15.587a1.6 1.6 0 0 0-1.202-.549h-4.177a3.724 3.724 0 0 1-3.721-3.721V7.14c0-.455-.198-.898-.548-1.202a1.58 1.58 0 0 0-1.249-.385c-2.742.35-5.262 1.855-6.907 4.119-1.656 2.275-2.263 5.051-1.738 7.828.758 4.013 3.967 7.222 7.992 7.98a9.8 9.8 0 0 0 1.925.187 9.9 9.9 0 0 0 5.891-1.925c2.264-1.645 3.769-4.165 4.119-6.907a1.57 1.57 0 0 0-.385-1.248"
  })));
};
export default SvgGraph;